import state from './resourcetag.state'
import mutations from './resourcetag.mutations'
import actions from './resourcetag.actions'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
